<template>
  <div class="radios">
    <div class="radio-wrap" :key="radioValue.id || radioValue.value" v-for="radioValue in preparedValues"
      :class="{
        'radio_inline_big-margins': inlineBigMargins,
        'radio_inline': inline,
      }"
    >
      <label :for="radioValue.id || radioValue.value" class="radio-label">
        <input
          type="radio"
          class="radio-input"
          :name="radioValue.name"
          :id="radioValue.id || radioValue.value"
          :value="radioValue.value"
          :class="{'radio-input_disabled' :radioValue.disabled}"
          :disabled="radioValue.disabled"
          v-model="selectedValue"
        >
        <span class="radio-circle"></span>
        <div class="radio-text">{{radioValue.text || radioValue.value}}</div>
      </label>
      <tooltip class="tooltip" v-if="radioValue.tooltip">{{ radioValue.tooltip }}</tooltip>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Number, Object],
    radioValues: Array,
    inline: Boolean,
    inlineBigMargins: Boolean,
    valueIsObj: Boolean,
  },
  data() {
    return {
    };
  },
  mounted() {
    if (!this.selectedValue) {
      const checkedDefault = this.preparedValues.find(p => p.checkedDefault);
      if (checkedDefault) {
        this.selectedValue = checkedDefault.value;
      }
    }
  },
  computed: {
    selectedValue: {
      get() {
        return this.valueIsObj ? this.value.value : this.value;
      },
      set(val) {
        if (this.valueIsObj) {
          const valObj = this.preparedValues.find(v => v.value === val);
          this.$emit('input', valObj);
        } else {
          this.$emit('input', val);
        }
      },
    },
    preparedValues() {
      if (typeof this.radioValues[0] === 'object') {
        return this.radioValues;
      }
      return this.radioValues.map(r => ({
        id: r,
        name: r,
        value: r,
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
.radio-input {
  display: none;
  &:checked {
    & + .radio-circle:after {
      opacity: 1;
      background: $red-color3;
      transform: scale(5);
    }
  }
  &_disabled {
    & + .radio-circle {
      border-color: $grey-color7;
      cursor: not-allowed;
      & + .radio-text {
        color: $grey-color2;
      }
    }
  }
}

.radio_inline_big-margins {
  display: inline-block;
  margin-right: 66px;
}

.radio_inline {
  display: inline-block;
  margin-right: 31px;
  .value-types & {
    margin-right: 41px;
  }
  .alert-types & {
    margin-right: 49px;
  }
  &:last-child {
    margin-right: 0;
  }
}

.radio-label {
  user-select: none;
}

.radio-circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: $white-color2;
  display: inline-flex;
  vertical-align: middle;
  border: 2px solid $red-color3;
  cursor: pointer;
  &:after {
    content: "";
    margin: auto;
    display: inline-block;
    width: 2px;
    height: 2px;
    border-radius: 50%;
    transition: 0.6s;
    background: $white-color2;
  }
}

.tooltip {
  display: inline-block;
  vertical-align: middle;
  margin-left: 8px;
  margin-top: 3px;
}

.radio-text {
  font-size: 13px;
  margin-left: 9px;
  display: inline-block;
  user-select: none;
  vertical-align: middle;
}

.radio-wrap:not(:last-child) {
  margin-bottom: 24px;
}
@media only screen and (max-width : 1042px) {
  .type {
    .radio-wrap {
      display: inline-block;
      &:not(:first-child) {
        margin-left: 129px;
      }
    }
  }
}
@media only screen and (max-width : 800px) {
  .type {
    .radio-wrap {
      display: block;
      &:not(:first-child) {
        margin-left: 0;
      }
    }
  }
}

@media only screen and (max-width : 432px) {
  .alert-types,
  .value-types {
    .radio_inline {
      display: block;
    }
    .radio-wrap {
      margin-bottom: 15px;
    }
  }
}

.settings__fiat-radios {
  .radio-text {
    margin-left: 7px;
  }
  @include  mobileStyles {
    .radio-text {
      margin-left: 13px;
    }
    .radio_inline_big-margins {
      margin-right: 61px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/uikit/RadioEl.vue